import { render } from "./QuotesTab.vue?vue&type=template&id=2f0e80fe&scoped=true"
import script from "./QuotesTab.vue?vue&type=script&lang=js"
export * from "./QuotesTab.vue?vue&type=script&lang=js"

import "./QuotesTab.vue?vue&type=style&index=0&id=2f0e80fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0e80fe"]])

export default __exports__